import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5e019a2f&"
import script from "./App.js?vue&type=script&lang=js&"
export * from "./App.js?vue&type=script&lang=js&"
import style0 from "../sass/bootstrap.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./App.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/frameto/WebSites/U3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5e019a2f', component.options)
    } else {
      api.reload('5e019a2f', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=5e019a2f&", function () {
      api.rerender('5e019a2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/App.vue"
export default component.exports